<template>
  <div class="new-style">
    <div class="footer">
      <div class="footer-nav">
        <img src="@/assets/images/logo2.png" alt="logo" />
        <el-menu ref="menu" class="el-menu-demo" mode="horizontal" background-color="#2F3645" text-color="#FFFFFF99"
          active-text-color="#FFFFFF" @select="handleSelect">
          <el-submenu index="1" popper-class="xsqy">
            <template slot="title">成员企业</template>

            <el-menu-item v-for="(item, index) in companyList" :key="index" :index="item.menuId.toString()"
              @click="goBannerDetail(item.menuId)"><span>{{ item.name }}</span></el-menu-item>
          </el-submenu>
          <el-submenu index="2" popper-class="sjjg">
            <template slot="title">上级机关</template>
            <el-menu-item index="2-1"><a href="http://sasac.tj.gov.cn/" target="_blank"
                title="天津市人民政府国有资产监督管理委员会">天津市人民政府国有资产监督管理委员会</a></el-menu-item>
          </el-submenu>
          <el-submenu index="3" popper-class="jbfs">
            <template slot="title">举报方式</template>
            <!-- <el-menu-item index="3-1"> -->
            <div class="jbfs-con">
              <div class="jbfs-con-title">天津市纪委监委监督举报方式</div>
              <div>举报电话：022-12388</div>
              <div>举报网址：https://tianjin.12388.gov.cn/</div>
              <div class="jbwx">举报微信：海河清风微信公众号“四风”举报专区</div>

              <div class="jbfs-con-title">假冒国企挂靠经营举报渠道</div>
              <div>企业名称：天津市旅游（控股）集团有限公司</div>
              <div>举报邮箱：jtgzcb@126.com</div>
              <div>答复电话：022-28369425</div>
              <div>答复期限：48小时内</div>
            </div>
            <!-- </el-menu-item> -->
          </el-submenu>
          <el-submenu index="4" popper-class="sjjg">
            <template slot="title">友情链接</template>
            <el-menu-item v-for="(item, index) in youqingList" :key="index" :index="item.menuId.toString()"
              @click="goBannerDetail(item.menuId)"><span>{{ item.name }}</span></el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
      <div class="footer-con">
        <div class="footer-inner">
          <div class="footer-inner-left">
            <div class="footer-inner-one">
              <!-- <div class="footer-inner-left-tit"></div> -->
              <div class="footer-inner-left-title">集团网站群</div>
            </div>
            <div class="line short"></div>
            <div class="footer-inner-left-title1" v-for="item in jtList" :key="item.id">
              <a :href="item.outerSiteUrl" target="_blank" :title="item.title">{{ item.title }}</a>
            </div>
          </div>
          <div class="footer-inner-con">
            <div class="footer-inner-one">
              <!-- <div class="footer-inner-left-tit"></div> -->
              <div class="footer-inner-left-title">联系我们</div>
            </div>
            <div class="line"></div>
            <template v-for="(item, index) in lxForm.contents">
              <div v-if="!!item" class="footer-inner-left-title1" :key="index">
                <div class="footer-inner-left-title2">
                  <!-- 地址：天津市河西区友谊路18号 -->
                  <img :src="contentsImg[index / 2]" alt="" />
                  {{ item }}
                </div>
                <!-- <div class="footer-inner-left-title2">邮编：300074</div>
                 <div class="footer-inner-left-title2">电话：022-28138223</div>
                 <div class="footer-inner-left-title2">传真：022-28130019</div> -->
              </div>
            </template>
          </div>
          <div class="footer-inner-right">
            <div class="footer-inner-right-con">
              <div class="footer-inner-one">
                <!-- <div class="footer-inner-left-tit"></div> -->
                <div class="footer-inner-left-title">关注我们</div>
              </div>
              <div class="line"></div>
              <div class="footer-inner-right-con-list">
                <div v-for="item in codeList" :key="item.id" class="footer-inner-right-con-li">
                  <img :src="item.image.path" alt="" height="160px" width="160px" />
                  <div class="tjlyjt">{{ item.title }}</div>
                </div>
              </div>
              <!-- <div class="footer-inner-right-con-li">
                <img
                  src="@/assets/images/lyjt.jpg"
                  alt=""
                  height="130px"
                  width="130px"
                />
                <div class="tjlyjt">天津旅游集团</div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      companyList: [],
      youqingList: [],
      search: {
        page: 1,
        size: 10,
      },
      ldId: "",
      jtList: [],
      lxForm: {},
      codeList: [],
      contentsImg: [
        require("@/assets/images/loc_icon.png"),
        require("@/assets/images/mail_icon.png"),
        require("@/assets/images/phone_icon.png"),
        require("@/assets/images/fax_icon.png"),
      ],
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getMenus();
    this.getJt();
    this.getLx();
    this.getCode();
  },
  mounted() { },
  beforeDestroy() { },
  methods: {
    getMenus() {
      axios.get("/jtg/home/menus").then((result) => {
        let res = JSON.parse(JSON.stringify(result.data));
        res.data.forEach((item) => {
          if (item.state !== 1) {
            return;
          }

          if (item.dictLabel == "成员企业" && item.name != "成员企业") {
            this.companyList.push(item);
          }
          if (item.dictLabel == "友情链接" && item.name != "友情链接") {
            this.youqingList.push(item);
          }
        });
      });
    },
    getJt() {
      axios.get("/jtg/home/group").then((result) => {
        let res = JSON.parse(JSON.stringify(result.data));
        this.jtList = res.data;
      });
    },
    getLx() {
      axios.get("/jtg/home/contact").then((result) => {
        let res = JSON.parse(JSON.stringify(result.data));
        this.lxForm = res.data;
      });
    },
    getCode() {
      axios.get("/jtg/home/code").then((result) => {
        let res = JSON.parse(JSON.stringify(result.data));
        this.codeList = res.data;
      });
    },
    goBannerDetail(id) {
      let params = {
        pageNum: this.search.page,
        pageSize: this.search.size,
        menuId: id,
      };
      // let ldId;
      axios.get("/jtg/home/articleList", { params }).then((result) => {
        let res = JSON.parse(JSON.stringify(result.data));

        this.ldId = res.data.items[0].id;
        // console.log(this.ldId,777);
        // this.getLdtd(ldId);
        this.$router.push("/bannerDetail?index=" + this.ldId);
      });
      // this.$router.push("/bannerDetail");
    },
    handleSelect() {
      this.$refs.menu.activeIndex = '';
    },
  },
};
</script>
<style lang="scss">
.el-menu--popup {
  //   height: 300px;
  //   width: 850px;
  display: flex;
  flex-wrap: wrap;
  background-color: #fff !important;
}

.xsqy {
  border: none !important;

  .el-menu {
    width: 1100px !important;
    background-color: rgba(255, 255, 255, 0.85) !important;

    .el-menu-item {
      background-color: #fff !important;
      color: #004aba !important;
      font-weight: 400;
      width: 250px;
      height: 30px !important;
      font-size: 14px;
      margin: 9px;
      text-align: center;

      span {
        // width: 10%;
        font-size: 14px;
      }
    }
  }
}

.sjjg {
  border: none !important;

  .el-menu {
    width: 300px !important;
    background-color: rgba(255, 255, 255, 0.85) !important;

    .el-menu-item {
      background-color: #fff !important;
      color: #004aba !important;
      font-weight: 400;
      width: 280px;
      height: 30px !important;
      font-size: 14px;
      margin: 9px;
      text-align: center;

      a {
        // width: 10%;
        font-size: 14px;
        text-decoration: none;
      }
    }
  }
}

.jbfs {
  .jbfs-con {
    padding: 10px 0 0 10px;
  }

  .jbwx {
    margin-bottom: 20px;
  }

  border: none !important;

  .el-menu {
    height: 240px;
    width: 380px !important;
    background-color: rgba(255, 255, 255, 0.85) !important;

    .el-menu-item {
      background-color: #fff !important;
      color: #004aba !important;
      font-weight: 400;
      width: 280px;
      height: 30px !important;
      font-size: 14px;
      margin: 9px;
      text-align: center;

      a {
        // width: 10%;
        font-size: 14px;
        text-decoration: none;
      }
    }
  }
}

::v-deep .el-menu-item {
  font-size: 14px !important;
  color: #fff !important;
}

.tjlyjt {
  text-align: center;
  margin-top: 14px;
  font-size: 14px;
  color: #fff;
}

.line {
  width: 100%;
  height: 1px;
  margin: 17px 0;
  background-color: rgba(255, 255, 255, 0.3);
}

.footer-inner-right {
  margin-left: 50px;
  width: 310px;
}

.footer-inner-right-con {
  display: flex;
  margin-top: 40px;
  // margin-right: 35px;
}

.footer-inner-right-con-li {
  margin-right: 35px;
}

.footer-inner-con {
  width: 310px;
}

.footer-inner-one {
  display: flex;
  align-items: center;
}

.footer-inner-left {
  margin-right: 50px;
  width: 310px;
}

.footer-inner-left-tit {
  /* position: absolute;
  left: 0;
  top: 8px; */
  margin-right: 10px;
  content: "";
  display: block;
  width: 10px;
  height: 10px;
  background-color: #00eb9b;
}

.footer-inner-left-title {
  font-size: 18px;
  color: #fff;
}

.footer-inner-left-title2 {
  color: #fff;
  font-size: 16px;
  margin-top: 18px;
}

.footer-inner-left-title1 a {
  color: #fff;
  font-size: 16px;
  text-decoration: none;
  cursor: pointer;
}

.footer-inner {
  display: flex;
  padding-top: 30px;
  margin-left: 462px;
}

.footer-con {
  height: 280px;
  min-width: 1200px;
  background-color: #004aba;
}

.footer-nav {
  height: 51px;
  min-width: 1200px;
  background-color: #023a8f;

  .cyqy {
    width: 850px !important;
  }

  //   .el-menu--horizontal {
  //     width: 850px !important;
  //   }
}
</style>
<style lang="scss" scoped>
.new-style {
  .footer-con {
    background-color: #272c37;
    height: 488px;
    box-sizing: border-box;
    padding-top: 70px;
  }

  .footer-inner {
    display: flex;
    margin: 0 auto;
    width: 1600px;
  }

  .footer-inner-left,
  .footer-inner-con,
  .footer-inner-right {
    flex: 1;
  }

  .footer-inner-left-title,
  .footer-inner-con-title,
  .footer-inner-right-title {
    font-weight: 500;
    font-size: 28px;
    line-height: 42px;
  }

  .footer-inner-left-title1,
  .footer-inner-con-title1,
  .footer-inner-right-title1 {

    &,
    a,
    .footer-inner-left-title2 {
      font-weight: 300;
      font-size: 22px;
      line-height: 30px;
      letter-spacing: 0.05em;
    }
  }

  .footer-inner-left-title2 {
    display: flex;
    margin-top: 0;
    line-height: 48px !important;
    align-items: center;

    img {
      width: 26px;
      height: 26px;
      flex-shrink: 0;
      margin-right: 8px;
    }
  }

  .footer-inner-right-con {
    display: block;
    margin-top: 0;

    .footer-inner-right-con-list {
      display: flex;
      width: 100%;
      flex-wrap: wrap;
      justify-content: flex-start;
      gap: 45px;
    }

    .footer-inner-right-con-li {
      flex: 1;
      text-align: center;
    }

    .tjlyjt {
      font-size: 24px;
      line-height: 30px;
      font-weight: 300;
      letter-spacing: 0.05em;
    }
  }

  .line {
    margin: 24px 0;
    opacity: 0.1;
    background-color: #fff;

    &.short {
      width: 140px;
    }
  }

  // ================== footer menu ==================
  .footer-nav {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    height: 160px;
    background-color: #2f3645;

    img {
      width: 406px;
      height: 62px;
      margin-right: 164px;
    }
  }

  ::v-deep .el-menu-demo {
    display: flex;
    justify-content: center;
    border-bottom: 0 !important;
    height: 160px;

    .el-submenu {
      position: relative;

      &::after {
        content: "";
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        width: 2px;
        height: 24px;
        background-color: #636363;
      }

      &:nth-last-child(1)::after {
        display: none;
      }
    }

    .el-menu-item,
    .el-submenu .el-submenu__title {
      position: relative;
      width: 176px;
      height: 160px;
      line-height: 146px;
      background-color: transparent !important; // 强制盖住Hover样式
      transition: all 0.3s ease !important;
      margin: 0 40px;

      &,
      span {
        font-size: 22px !important;
      }
    }

    .el-menu-item.is-active,
    .el-menu-item:hover,
    .el-submenu.is-active .el-submenu__title,
    .el-submenu:hover .el-submenu__title {
      z-index: 2;
      color: #ffffff !important;
      font-weight: bold;

      .el-submenu__icon-arrow {
        color: #ffffff;
      }
    }

    .el-submenu .el-submenu__icon-arrow {
      position: absolute;
      width: 16px;
      font-size: 16px;
      font-weight: bold;
      margin: 0 0 0 -8px;
      left: 50%;
      top: auto;
      bottom: 30px;
    }
  }
}
</style>
<style lang="scss">
.xsqy,
.sjjg,
.jbfs {
  .el-menu--popup {
    border-radius: 8px;
    border: 0 !important;
  }

  &>.el-menu {
    margin-left: -30px;
  }

  .el-menu {
    width: 320px;
    margin-top: 0;
    padding: 6px 0 !important;
    background-color: #ffffff66 !important;

    .el-submenu {
      width: 100%;
      text-align: center;

      span {
        display: inline-block;
        width: 100%;
        text-align: center;
      }
    }

    &.el-menu--popup {
      justify-content: center;
      padding: 12px 0 !important;

      .el-menu-item,
      .el-submenu__title {
        width: 320px !important;
        font-size: 16px;
        height: 40px !important;
        line-height: 40px !important;
        border-radius: 60px;
        border-left: 0 !important;
        margin: 4px;

        &,
        a {
          color: #000 !important;
        }
      }
    }
  }

  .el-submenu__icon-arrow {
    right: 10px;
    top: 0;
    line-height: 40px !important;
    margin: 0 !important;
  }

  .el-submenu .el-submenu__title:hover,
  .el-menu--popup .el-menu-item:not(.is-disabled):hover {
    background: #206bd1 !important;

    &,
    a {
      color: #fff !important;
    }

    .el-submenu__icon-arrow {
      color: #fff !important;
    }
  }
}

.xsqy {
  .el-menu {
    width: 680px !important;
    text-align: center;
  }
}

.sjjg {
  .el-menu {
    width: 340px !important;
  }
}

.jbfs {
  .jbfs-con {
    padding: 2px 15px;
  }

  .el-menu {
    width: 360px !important;
    background-color: #fff !important;
    color: #000 !important;
    font-size: 16px;
  }

  .jbfs-con-title {
    font-weight: bold;
    line-height: 24px;
  }
}
</style>